import { render } from "./NoticiaLeitura.vue?vue&type=template&id=68d431c2&scoped=true"
import script from "./NoticiaLeitura.vue?vue&type=script&lang=js"
export * from "./NoticiaLeitura.vue?vue&type=script&lang=js"

import "./NoticiaLeitura.vue?vue&type=style&index=0&id=68d431c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d431c2"]])

export default __exports__